import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year5/Autumn/MultiplicationAndDivisionA/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'MultiplicationAndDivisionA',
  field: 'Number',
  weeks: [6, 8],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/MultiplicationAndDivisionA/1Multiples" */ './1Multiples'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/MultiplicationAndDivisionA/2CommonMultiples" */ './2CommonMultiples'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/MultiplicationAndDivisionA/3Factors" */ './3Factors'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/MultiplicationAndDivisionA/4CommonFactors" */ './4CommonFactors'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/MultiplicationAndDivisionA/5PrimeNumbers" */ './5PrimeNumbers'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/MultiplicationAndDivisionA/6SquareNumbers" */ './6SquareNumbers'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/MultiplicationAndDivisionA/7CubeNumbers" */ './7CubeNumbers'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/MultiplicationAndDivisionA/8MultiplyBy10100And1000" */ './8MultiplyBy10100And1000'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/MultiplicationAndDivisionA/9DivideBy10100And1000" */ './9DivideBy10100And1000'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/MultiplicationAndDivisionA/10MultiplesOf10100And1000" */ './10MultiplesOf10100And1000'
        )
    })
  ]
});
export default Block;
